import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { ELinkSource } from '../../../constants';
import { segmentTrackAction, SegmentUserEvent } from '../../../../../../../middlewares/segment';

export const onClick = (
    source: ELinkSource
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        switch (source) {
            case ELinkSource.PRIVACY: {
                dispatch(segmentTrackAction(SegmentUserEvent.PRIVACY_HELP_PANEL_LINK_CLICKED));
                break;
            }
            case ELinkSource.TERMS: {
                dispatch(segmentTrackAction(SegmentUserEvent.TERMS_HELP_PANEL_LINK_CLICKED));
                break;
            }
            case ELinkSource.COOKIE: {
                dispatch(segmentTrackAction(SegmentUserEvent.COOKIE_HELP_PANEL_LINK_CLICKED));
                break;
            }
            case ELinkSource.ACCESSIBLE: {
                dispatch(segmentTrackAction(SegmentUserEvent.ACCESSIBLE_HELP_PANEL_LINK_CLICKED));
                break;
            }
            default: {
                return;
            }
        }
    };
    return action;
};
